var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rabbey-table-3',{attrs:{"data":_vm.reportData,"columns":_vm.columns,"actions":[]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }